import { render } from "./UsersRole.vue?vue&type=template&id=6d3c1e8b"
import script from "./UsersRole.vue?vue&type=script&lang=js"
export * from "./UsersRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__